import { render, staticRenderFns } from "./LazyloadDefaultLayout.vue?vue&type=template&id=d0a97ea2&scoped=true"
import script from "./LazyloadDefaultLayout.vue?vue&type=script&lang=js"
export * from "./LazyloadDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a97ea2",
  null
  
)

export default component.exports